import { http } from '@Techedge/digitalportal-shared'

export class TableConfigService {
	static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
	static TABLE_CONFIG_URL: string =
		TableConfigService.BASE_URL + `/filtersapi/table_config?idTable=`

	static headersObj = {
		headers: {
			'Accept-Language': '',
		},
		timeout: 180000,
	}

	static GetTableConfig = (tableId: string) => {
		return http.get<TableConfigResponse>(
			`${TableConfigService.TABLE_CONFIG_URL}${tableId}`,
			TableConfigService.headersObj
		)
	}

	static PutTableConfig = (tableId: string, config: TableConfigResponse) => {
		return http.put<any>(
			`${TableConfigService.TABLE_CONFIG_URL}${tableId}`,
			config,
			TableConfigService.headersObj
		)
	}
}

type TableConfigResponse = {
	rearrangeOrder: string[]
	columns: Record<string, { value: any; orderBy: 'ASC' | 'DESC' }>
}
